"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var dayjs = require("dayjs");
var utc = require("dayjs/plugin/utc");
var timezone = require("dayjs/plugin/timezone"); // dependent on utc plugin
var _require = require("../../constants"),
  DATE_FORMATS = _require.DATE_FORMATS;
dayjs.extend(utc);
dayjs.extend(timezone);
var BaseStringHandler = require("../BaseStringHandler");
var DateHandler = /*#__PURE__*/function (_BaseStringHandler) {
  function DateHandler() {
    var _this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, DateHandler);
    _this = _callSuper(this, DateHandler);
    (0, _defineProperty2["default"])(_this, "dateFormat", "long");
    (0, _defineProperty2["default"])(_this, "timezone", "utc");
    var dateFormat = config.dateFormat,
      timezone = config.timezone;
    _this.dateFormat = dateFormat !== null && dateFormat !== void 0 ? dateFormat : "long";
    _this.timezone = timezone !== null && timezone !== void 0 ? timezone : "utc";
    return _this;
  }
  (0, _inherits2["default"])(DateHandler, _BaseStringHandler);
  return (0, _createClass2["default"])(DateHandler, [{
    key: "validate",
    value: function validate(value) {
      return value instanceof Date && dayjs.utc(value).isValid();
    }
  }, {
    key: "processWithTimezone",
    value: function processWithTimezone(date) {
      var timezone = this.timezone.toLowerCase();
      switch (timezone) {
        case "utc":
          return dayjs.utc(date);
        case "local":
          return dayjs(date);
        default:
          return dayjs.utc(date).tz(this.timezone);
      }
    }
  }, {
    key: "format",
    value: function format(value) {
      var date = this.processWithTimezone(value);
      if (!date.isValid()) {
        return "";
      }
      return date.format(DATE_FORMATS[this.dateFormat]);
    }
  }]);
}(BaseStringHandler);
module.exports = DateHandler;